export const fiscalRecharge = {
	titleTab: "Configuración de recarga",
	titleColumnsTable: {
		place: "Local",
		fiscalProfile: "Perfil fiscal",
		fiscalGroup: "Grupo fiscal",
		ncm: "NCM",
		action: "Acción",
	},
	placeholders: {
		fiscalProfile: "Seleccione un perfil fiscal",
		fiscalGroup: "Seleccione un grupo fiscal",
		ncm: "Ingrese el código NCM",
	},
	errors: {
		requiredField: "Campo obligatorio",
		invalidFormatNcm: "El NCM debe contener 8 dígitos",
	},
	messageWarning:
		"Al cancelar esta acción, las modificaciones realizadas no se aplicarán. ¿Desea continuar de todos modos?",

	titleButtonOut: "Salir sin guardar",
};
